import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';

import OnlineIndicatorStore from 'flux/stores/OnlineIndicatorStore';

/**
 * Indicates whether the user is 'online'
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(OnlineIndicatorStore, 'online')],

  displayName: 'OnlineIndicator',

  // eslint-disable-next-line react/display-name
  render: function () {
    const { online } = this.state;
    const internetConnected = online.get('internetOnline');
    const socketConnected = online.get('socketOnline');

    const isOnline = internetConnected && socketConnected;
    return (
      <div className={classNames('online-indicator', { online: isOnline })} />
    );
  },
});
